import { observable, action } from "mobx";
import { post,get,deleted, put } from "../services/ajax.service";

class SavedContractStore {
  @observable save_message = "";
  @observable error = "";
  @observable contracts = [];
  @observable single_instance_contracts = [];
  @observable url = "/api/v1/savedcontractsaction";


  @action create =async (data) => {
    this.save_message = "";
    this.error = "";
    try {
      let response = await post(
        `${this.url}/create`,
        data
      );
      if (response.data) {
        this.save_message = "Saved Successfully";
      }
    } catch (err) {
      if(err.response.data.name){
        this.error=err.response.data.name;
        console.log(err);
        return;
      }
      this.error=err.response.data;
      console.log(err);
    }
  }

  @action update =async (data) => {
    this.save_message = "";
    this.error = "";
    try {
      let response = await put(
        `${this.url}/update/${data.id}`,
        data
      );
      if (response.data) {
        this.save_message = "Updated Successfully";
      }
    } catch (err) {
      if(err.response.data.name){
        this.error=err.response.data.name;
        console.log(err);
        return;
      }
      this.error=err.response.data;
      console.log(err);
    }
  }
  // @action getAll =async (data) => {
  //   this.contracts=[];
  //   this.error = "";
  //   try {
  //     let response = await post(
  //       `${this.url}/getAll`,
  //       data
  //     );
  //     this.contracts=response.data.rows;
  //   } catch (err) {
  //     this.error=err.response.data;
  //     console.log(err);
  //   }

  // }

  @action getAll = async (data) => {
    this.contracts = [];
    this.error = "";
    try {
      let response = await post(
        `${this.url}/getAll`,
        data
      );
      const filteredContracts = response.data.rows.filter(row => !/Market_Check_Package__\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/.test(row.name));
      this.contracts = filteredContracts;
    } catch (err) {
      this.error = err.response.data;
      console.log(err);
    }
  }

  
  
  @action get =async (id) => {
    console.log(id)
    this.single_instance_contracts=[];
    this.error = "";
    try {
      let response = await get(
        `${this.url}/get/${id}`
      );
      this.single_instance_contracts=response.data;
      return response.data;
    } catch (err) {
      this.error=err.response.data;
      console.log(err);
    }

  }

  @action deleteContract = async (id) => {
    try {
      await deleted(`${this.url}/delete/${id}`);
      var filtered = this.contracts.filter(user => user.id !== id);
      this.contracts = filtered;
    } catch (e) {
      console.log(e);
    }
  }
}


export default SavedContractStore;
